import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorBodyStyleAll: [],
    motorBodyStyle: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const motorBodyStyleSlice = createSlice({
    name: "motorBodyStyle",
    initialState,
    reducers: {
        setMotorBodyStyleAll: (state, action) => {
            state.motorBodyStyleAll = action.payload;
        },
        setMotorBodyStyle: (state, action) => {
            state.motorBodyStyle = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})

export const { setMotorBodyStyleAll, setMotorBodyStyle, setCurrentPage, setTotalPages, setRowsPerPage } = motorBodyStyleSlice.actions;
export default motorBodyStyleSlice.reducer;